import { deepClone } from '@luna/utils';

import { setGatekeeperFeatures } from './isFeatureEnabled';

export const initFeatures = <T>(initialFeatures = {} as T): T => {
    const defaultFeatures = deepClone(initialFeatures);

    setGatekeeperFeatures({
        features: defaultFeatures,
        featuresWithoutCustomOverrides: defaultFeatures,
        defaultFeatures,
    });

    return defaultFeatures;
};
